import React, {useCallback} from 'react';
import {
    DoppeActionTypeWidgetInnerButton
} from '../../../doppe-action-type-widget-inner-button/doppe-action-type-widget-inner-button';
import {assertNotNullable, OmitStrict} from '@wix/devzai-utils-common';

import {
    DoppeActionCTAButtonMultiple,
    DoppeActionCTAButtonSingle,
    doppeActionCtaButtonTypeGetGoalType,
    DoppeActionSettingsCTAButtonSettings
} from '../../../../client-server-common/types/doppe-action-cta-button';
import {
    DoppeActionTypeWidgetInnerCtaButton
} from '../../../doppe-action-type-widget-inner-cta-button/doppe-action-type-widget-inner-cta-button';
import {DoppeActionGoalType} from '../../../../client-server-common/doppe-action-types/doppe-action-type';
import {
    doppeViewerActionCtaButtonTypeResolveOnClick
} from '../../../../doppe-sdk/doppe-viewer-action-context/doppe-viewer-action-context-utils';
import {useDoppeViewerLocales} from '../../../../client/doppe-viewer-locales/doppe-viewer-locales';
import {useEventCallback, useObservableCalculatedValue} from '@wix/devzai-utils-react';
import {
    useDoppeViewerHtmlSiteInfo
} from '../../../doppe-viewer-bymo-page-props-react/doppe-viewer-bymo-page-props-react';
import {
    doppeActionCtaButtonTypeGetLinkSettings
} from '../../../../doppe-action-types/doppe-actions-common/doppe-cta-button-utils/doppe-cta-button-utils';
import {IDoppeViewerActionContext} from '../../../../doppe-sdk';

export const DoppeActionTypeWidgetInnerLinkTypeCtaButtonOpenPage = React.memo(function DoppeActionTypeWidgetInnerLinkTypeCtaButtonOpenPage(props: DoppeActionTypeWidgetInnerLinkTypeCtaButtonOpenPage.Props) {
    const {
        ctaButton,
        sourceURL,
        ctaCallback,
        onClick,
        listItemId,
        actionContext,

        ...htmlAttributes
    } = props;

    const viewerLocales = useDoppeViewerLocales();
    const htmlSiteInfo = assertNotNullable(useDoppeViewerHtmlSiteInfo());

    const observableButtonSettings = useObservableCalculatedValue(useCallback(() => {
        return ctaButton.settings;
    }, [ctaButton.settings]));


    const linkSettings = doppeActionCtaButtonTypeGetLinkSettings(ctaButton, {
        sourceURL: sourceURL,
        actionId: props.actionContext.action.id,
        innerItemId: listItemId,
        htmlSiteInfo: htmlSiteInfo,
    })

    const onClickCustomCallback = doppeViewerActionCtaButtonTypeResolveOnClick(ctaButton, {
        actionContext: actionContext,
        ctaCallback: ctaCallback,
        observableButtonSettings: observableButtonSettings,
        listItemId: listItemId,
        viewerLocales: viewerLocales,
        htmlSiteInfo: htmlSiteInfo
    })

    const onButtonClick = useEventCallback(() => {
        const goalType = doppeActionCtaButtonTypeGetGoalType(ctaButton.settings.type);
        onClickCustomCallback?.(sourceURL)
        onClick(goalType);
    })

    return (
        <DoppeActionTypeWidgetInnerCtaButton
            {...htmlAttributes}
            {...linkSettings}
            actionContext={actionContext}
            onClick={onButtonClick}
            children={ctaButton.text}
        />
    );
});

export namespace DoppeActionTypeWidgetInnerLinkTypeCtaButtonOpenPage {

    export interface Props extends OmitStrict<DoppeActionTypeWidgetInnerButton.Props, 'suffixIcon' | 'target' | 'href' | 'tagName' | 'children' | 'onClick'> {
        actionContext: IDoppeViewerActionContext<any>;
        ctaButton: DoppeActionCTAButtonSingle | DoppeActionCTAButtonMultiple;
        sourceURL?: string;
        ctaCallback?: (settings: DoppeActionSettingsCTAButtonSettings) => void;
        onClick: (goalType: DoppeActionGoalType) => void;
        listItemId?: string;
    }

}
